import Vue from 'vue'
import store from '@/store'
import { Notification } from 'element-ui'

export default async (loginData) => {
  try {
    const res = await Vue.axios.get('/auth/token', {
      auth: {
        username: loginData.email,
        password: loginData.password
      }
    })
    store.dispatch('login', res.data)
  } catch (e) {
    Notification({message: 'Email hoặc mật khẩu không đúng.', showClose: false, duration: 3000, customClass: 'error'})
  }
}



// WEBPACK FOOTER //
// ./src/services/auth/login.js